import Full from './Full';
import Modal from './Modal';

const Loaders = {
  Full,
  Modal
};

export default Loaders;
